import React from "react";
import Odometer from "../../../UI/Odometer/Odometer";
import classes from "./Figure.module.css";

//This Component renders 2 divs with Odometers inside to show some numbers with an icon in between
//and a title beneath
// prop = { leftNumber, rightNumber, icon, title}
const Figure = (props) => {
  return (
    <div className={classes.container}>
      <div className={classes.row}>
        <div className={classes.leftCard}>
          <div className={classes.numberContainer}>
            {props.static ? (
              <div className={classes.leftNb}>{props.leftNumber}</div>
            ) : (
              <Odometer
                value={props.leftNumber}
                height={40}
                className={classes.yellow + " " + classes.number}
                commaClassName={classes.blue}
                duration={1}
              />
            )}
          </div>
          <div className={classes.label + " " + classes.yellow}>Disabled</div>
        </div>
        <img src={props.icon} alt="icon" className={classes.icon} />
        <div className={classes.rightCard}>
          <div className={classes.numberContainer}>
            {props.static ? (
              <div className={classes.rightNb}>{props.rightNumber}</div>
            ) : (
              <Odometer
                value={props.rightNumber}
                height={40}
                className={classes.blue + " " + classes.number}
                commaClassName={classes.yellow}
                duration={1}
              />
            )}
          </div>
          <div className={classes.label + " " + classes.blue}>Non-Disabled</div>
        </div>
      </div>
      <div className={classes.row}>
        <h5>{props.title}</h5>
      </div>
    </div>
  );
};
export default Figure;
